export default {"src":"/_next/static/media/marks.ee2aa2ee.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};